<template>
  <div class="tracker" :class="getStepClass">
    <div class="tracker-icons">
      <div class="top-bar">
        <div class="circle-plane" title="Sending to Publisher"></div>
      </div>

      <div class="lower-bar">
        <div class="circle-tick" title="Order Placed"></div>
        <div class="circle-deliver" title="Order with publisher"></div>
      </div>
    </div>
    <div class="tracker-progress">
      <div class="bar"></div>
      <div class="bar-hide"></div>

      <div class="bar-highlight"></div>
      <div class="bar-highlight-hide">
        <span class="meter-header">{{ title }}</span>
        <a v-if="subtitle" class="meter-content" v-on:click="showDialog = true">{{ subtitle }}</a>
      </div>
    </div>

    <div class="overlay-wrapper" v-if="showDialog">
      <div class="dialog">
        <button v-on:click="showDialog = false">X</button>
        <div class="questions">
          <h3><slot name="dialogTitle">What does this mean</slot></h3>
          <p>
            <slot name="dialogBody"></slot>
          </p>
          <a class="close" v-on:click="showDialog = false">Close</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Tracker",
  props: {
    step: Number,
    title: String,
    subtitle: String,
    explain: String
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    getStepClass() {
      return "step-" + this.step;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$background-color: #222;
$outline-color: #444;
$highlight-color: #fff;
$highlight-circle-color: #aaa;

.tracker {
  text-align: center;
  width: 350px;
  height: 400px;
  margin: 0 auto;
  position: relative;

  .bar,
  .bar-highlight {
    margin-top: 0px;
    display: block;
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    z-index: 100;
  }

  .bar-hide,
  .bar-highlight-hide {
    margin-top: 1px;
    display: flex;
    position: absolute;
    width: 285px;
    height: 285px;
    border-radius: 50%;

    flex-direction: column;
    justify-content: center;
    z-index: 120;
  }

  .bar {
    background: conic-gradient(from 0.7turn, $outline-color, 0.6turn, rgba(0, 0, 0, 0) 0 350deg);
  }

  .bar-hide {
    background: conic-gradient(from 0.7turn, $background-color, 0.6turn, rgba(0, 0, 0, 0) 0 350deg);
  }

  &.step-1 {
    .bar-highlight {
      background: conic-gradient(from 0turn, $highlight-color, 0turn, rgba(0, 0, 0, 0) 0 350deg);
    }

    .bar-highlight-hide {
      background: conic-gradient(from 0turn, $background-color, 0turn, rgba(0, 0, 0, 0) 0 350deg);
    }

    .circle-tick {
      border: 10px solid $background-color;
      animation-name: flash_border;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }

    .circle-plane {
      background-color: $outline-color;
      background-image: url("~@/assets/plane.png");
    }

    .circle-deliver {
      background-color: $outline-color;
      background-image: url("~@/assets/deliver.png");
    }
  }

  &.step-2 {
    .bar-highlight {
      background: conic-gradient(
        from 0.7turn,
        $highlight-color,
        0.3turn,
        rgba(0, 0, 0, 0) 0 350deg
      );
    }

    .bar-highlight-hide {
      background: conic-gradient(
        from 0.7turn,
        $background-color,
        0.3turn,
        rgba(0, 0, 0, 0) 0 350deg
      );
    }

    .circle-plane {
      border: 10px solid $background-color;
      animation-name: flash_border;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }

    .circle-deliver {
      background-color: $outline-color;
      background-image: url("~@/assets/deliver.png");
    }
  }

  &.step-3 {
    .bar-highlight {
      background: conic-gradient(
        from 0.7turn,
        $highlight-color,
        0.6turn,
        rgba(0, 0, 0, 0) 0 350deg
      );
    }

    .bar-highlight-hide {
      background: conic-gradient(
        from 0.7turn,
        $background-color,
        0.6turn,
        rgba(0, 0, 0, 0) 0 350deg
      );
    }

    .circle-deliver {
      border: 10px solid $background-color;
      animation-name: flash_border;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }
}

/*Process bar shapes*/
.tracker-progress {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
}

.meter-header {
  font-size: 30px;
  font-weight: bold;
  padding: 0 30px 0 30px;
  margin-top: -60px;
}

.meter-content {
  text-decoration: underline;
  padding: 10px 20px 0 20px;
}

/*Icons on process bar*/
.tracker-icons {
  position: absolute;
  height: 100%;
  width: 100%;

  .top-bar {
    z-index: 150;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-top: 20px;
    margin-bottom: 140px;
  }

  .lower-bar {
    z-index: 150;
    width: 95%;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 0 auto;
  }

  .circle-tick,
  .circle-plane,
  .circle-deliver {
    height: 60px;
    width: 60px;
    background: $highlight-color;
    background-repeat: no-repeat;
    border: 10px solid $background-color;
    background-position: center;
    border-radius: 50%;
  }

  .circle-tick {
    background-image: url("~@/assets/tick-select.png");
  }

  .circle-plane {
    background-image: url("~@/assets/plane-select.png");
  }

  .circle-deliver {
    background-image: url("~@/assets/deliver-select.png");
  }
}

@keyframes flash_border {
  0% {
    border-color: $background-color;
  }
  50% {
    border-color: $highlight-circle-color;
  }
  100% {
    border-color: $background-color;
  }
}
</style>
